module.exports = __webpack_public_path__ + "static/img/icn_invite_heart.6887ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icn_invite_heart.png
// module id = /P3Z
// module chunks = 1